import { render, staticRenderFns } from "./news.vue?vue&type=template&id=18be4c86&scoped=true"
import script from "./news.vue?vue&type=script&lang=js"
export * from "./news.vue?vue&type=script&lang=js"
import style0 from "./news.vue?vue&type=style&index=0&id=18be4c86&prod&lang=scss&scoped=true"
import style1 from "./news.vue?vue&type=style&index=1&id=18be4c86&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18be4c86",
  null
  
)

export default component.exports